import reduxStore from "utils/storeFactory";

const getIsSimulatedSource = () =>
  !!reduxStore.getState().story.isSimulatedSource;

export default getIsSimulatedSource;
